import React from 'react';
import styled from 'styled-components';
import { Table, TableBody, TableCell, TableContainer, Checkbox,TableHead, TableRow, Chip, TextField, Autocomplete } from '@mui/material';
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank';
import CheckBoxIcon from '@mui/icons-material/CheckBox';

const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
const checkedIcon = <CheckBoxIcon fontSize="small" />;

const ButtonWrapper =styled.div`
  display: flex;
  align-items: center;
  margin-right: 20px;
  height: 35px;
`


const SCMreadonlyrow = ({k,row, page, rowsPerPage, onClickEdit, handleDeleteClick, tableFontSize, SubmitButton})=>{
    return(
      
        <>
        
        <TableRow >
              <TableCell component="th" scope="row" align='center' sx={{ fontSize: tableFontSize}}>
                {(page)*(rowsPerPage)+k+1}
              </TableCell>
              <TableCell  align="left" sx={{ fontSize: tableFontSize}}>
                {row.Category}
              </TableCell>
              <TableCell  align="left" sx={{ fontSize: tableFontSize}}>
                {row.Name}
              </TableCell> 
              <TableCell  align="left" sx={{ fontSize: tableFontSize}}>
              {Object.keys(row)[2]? Object.keys(row)[2]:null}
              </TableCell>
              <TableCell  align="left" sx={{ fontSize: tableFontSize}}>
                {row[Object.keys(row)[2]]? row[Object.keys(row)[2]].map((item, index)=><Chip key={index} label={item} sx={{marginRight:"2px", marginBottom:"2px"}}/>):null }
              </TableCell>
              <TableCell align="left" sx={{ fontSize: tableFontSize}}>
                <ButtonWrapper>
                  <SubmitButton type='button' style={{backgroundColor:"#ed6c02", color:"lightgreen", height:"35px", margin:"0px"}} onClick ={(e)=>onClickEdit(e,k,row)}>Edit</SubmitButton>
                  <SubmitButton type='button' style={{backgroundColor:"#D32F2F", color:"lightgreen", height:"35px"}}  onClick ={(e)=>handleDeleteClick(e,k,row)}>Delete</SubmitButton>
                </ButtonWrapper>
              </TableCell>
            </TableRow>


        </>
    )

}

export default SCMreadonlyrow;